import { z } from 'zod';

import { IBaseEntity } from './base-entity.interface';

export const OrganizationIdSchema = z.string().brand('OrganizationId');
export type OrganizationId = z.infer<typeof OrganizationIdSchema> | string;

/**
 * An organization is a group of users that can share targets and scans
 */
export interface Organization extends IBaseEntity {
    id: OrganizationId;
    name: string;
    stripeCustomerId?: string;
}
